// Chat.jsx
import React, { useEffect, useRef, useState } from "react";

export default function Chat({ messages, onSend }) {
  const [text, setText] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div
      className="chat-panel"
      role="dialog"
      aria-label="Chat"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="chat-header">Chat</div>

      <div className="chat-messages">
        {messages.map((m, i) => (
          <div key={i} className="chat-msg">
            <div className="chat-name">{m.from}</div>
            <div className="chat-text">{m.text}</div>
            <div className="chat-time">{m.time}</div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <div className="chat-input">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          onDrop={(e) => {
            e.preventDefault();
            alert("Pasting/dropping text is disabled for interview integrity.");
          }}
          onPasteCapture={(e) => {
            e.preventDefault();
            e.stopPropagation();
            alert("Pasting is disabled for interview integrity.");
          }}
          onPaste={(e) => {
            e.preventDefault();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSend(text);
              setText("");
            }
          }}
          placeholder="Type a message"
        />
        <button
          type="button"
          onClick={() => {
            onSend(text);
            setText("");
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
}
